import React, { useContext, useMemo, useRef } from "react";
import { useParams } from "react-router-dom";
import { Box, Typography } from "@mui/material";

import { AccountContext } from "@context/AccountProvider";
import { useTranslation } from "react-i18next";

import SiteForm from "@component/SiteForm";

export default function SitePage() {
  const { uuid } = useParams();
  const { sites } = useContext(AccountContext);
  const containerRef = useRef(null);
  const site = useMemo(() => sites?.find((s) => s.uuid === uuid), [sites, uuid]);
  const { t } = useTranslation("main"); 

  if (!site) return <Typography sx={{ m: 4 }}>Site not found</Typography>;

  return (
    <Box 
      ref={containerRef}
      sx={{ 
        width: '100%', 
        maxWidth: '1700px',
        p: 2,
      }}
    >
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        mb: 4
      }}>
        <Box sx={{ 
          flex: 1,
          minWidth: 350,
          maxWidth: 700,
          mx: 'auto',
          width: '100%'
        }}>
          <Typography variant="h5" gutterBottom textAlign="left">
              {t("site")}
          </Typography>
          <SiteForm site={site}/>
        </Box>
      </Box>
    </Box>
  );
}
